import script from "./floorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./floorInfo.vue?vue&type=script&setup=true&lang=js"

import "./floorInfo.vue?vue&type=style&index=0&id=7f805039&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f805039"]])

export default __exports__